export const messagesSk = {
    Welcome: "Vitajte",
    Cartridge: "Kartridž",
    Poster: "Plagát",
    Documentation: "Dokumentácia",
    Map: "Mapa",
    "In-game Picture": "Obrázok z hry",
    "Loading game": "Nahrávam hru",
    "Author(s)": "Autor(i)",
    Publisher: "Vydavateľ",
    Released: "Vydané",
    "less then one year ago": "pred menej ako rokom",
    "one year ago": "pred rokom",
    "{{years}} years ago": "pred {{years}} rokmi",
    Information: "Informácie",
    Controls: "Ovládanie",
    "Number of Players": "Počet hráčov",
    Rating: "Hodnotenie",
    Graphics: "Grafika",
    Music: "Hudba",
    Sound: "Zvuk",
    Total: "Celkovo",
    Genre: "Žáner",
    "Added by": "Pridal",
    "File Format": "Formát súboru",
    Placement: "Umiestnenie",
    show: "Zobraiť",
    Games: "Hry",
    Administration: "Administrácia",
    "Add Game": "Vložiť hru",
    "Page Not Found": "Stánka sa nenašla",
    "Page not found. Check URL address and use top navigation bar...":
        "Stránka sa nenašla. Skontrolujte URL adresu a použite hornú navigáciu...",
    "Log-in": "Prihlásiť sa",
    Login: "Prihlásenie",
    "Login successful": "Bol(a) si úspešne prilásený(á)",
    "An error happened during login process": "Počas prihlasovania nastala chyba",
    "Wrong email or password maybe": "Možno zlý email alebo heslo",
    "Log-out": "Odhlásiť sa",
    Logout: "Odhlásenie",
    Password: "Heslo",
    "This field is mandatory": "Toto pole je povinné",
    "Not a proper email": "Nesprávna emailová adresa",
    "Password too short": "Heslo je príliš krátke",
    "Sign-out successful": "Bol(a) si úspešne odhlásený(á)",
    "An error happened during sign-out process": "Počas odhlasovania nastala chyba",
    "Try again, please": "Skúste to prosím znovu",
    "Add new game": "Vloženie novej hry",
    Title: "Názov",
    "At least one option needs to be selected": "Je potrebné vybrať aspoň jednu voľbu",
    "Testing date": "Dátum testovania",
    "Publishing date": "Dátum vydania",
    "Cracked date": "Dátum cracknutia",
    Filename: "Názov súboru",
    Description: "Popis",
    "Intro Picture": "Obrázok intra",
    "Menu Picture": "Obrázok menu",
    "Docs Picture": "Obrázok dokumentácie",
    "Poster Picture": "Obrázok plagátu",
    "Map Picture": "Obrázok mapy",
    "Cartridge Picture": "Obrázok kartridžu",
    "Number of In-game Pictures": "Počet obrázkov z hry",
    "External Review URL": "URL externej recenzie",
    Platform: "Platforma",
    Dates: "Dátumy",
    "Players amount": "Počet hráčov",
    "Game have trainer": "Hra má trainer",
    Files: "Súbory",
    required: "požadované",
    pictures: "obrázky",
    "Game added successfuly": "Hra bola úspešne pridaná",
    "An error occured during adding game": "Počas pridávania hry nastala chyba",
    "Show games by": "Zobraziť hry podľa",
    "Image is loading": "Obrázok sa nahráva",
    "Nr.": "Č.",
    "Top twenty games": "20 najlepších hier",
    "Worst twenty games": "20 najhorších hier",
    "Enter game title": "Vložte názov hry",
    "Search in {{numberOfGames}} games": "Hľadať v {{numberOfGames}} hrách",
    "No games found": "Nenašli sa žiadne hry",
    "Welcome to the site dedicated to computer games.": "Vitajte na stránkach venovaných počítačovým hrám.",
    "These pages aim to introduce you to games from the past.":
        "Tieto stránky majú za cieľ zoznámiť vás s hrami z minulosti.",
    "They currently contain games for": "Aktuálne obsahujú hry pre",
    "8-bit computer": "8-bitový počítač",
    "16-bit computer": "16-bitový počítač",
    "32-bit computer": "32-bitový počítač",
    "Everyone likes to play.": "Každý sa rád hraje.",
    "If you also played computer games in your childhood, I will be happy if you reminisce about your childhood together with me and my pages.":
        "Ak ste aj vy hrávali v detstve počítačové hry, budem rád, ak spolu so mnou a mojimi stránkami zaspomínate na detstvo.",
    "I wish you pleasant memories and": "Prajem vám príjemné spomínanie a",
    "browsing the pages": "prehliadanie stránok",
    "And if you are younger, I will be happy if you also use my pages to learn something about how we used to play, especially in the 90s of the last century.":
        "A ak ste mladší, budem rád, ak sa aj pomocou mojich stránok dozviete niečo o tom, ako sme sa najmä v 90. rokoch minulého storočia hrávali.",
    Slovak: "Slovensky",
    English: "Anglicky",
    "New twenty games": "20 najnovších hier",
    Edit: "Upraviť",
    "Edit Game": "Opraviť hru",
    "Edit game": "Oprava hry",
    "Game edited successfuly": "Hra bola úspešne upravená",
    "An error occured during game editing": "Počas úprav hry nastala chyba",
    "Date Cracked": "Dátum cracknutia",
    "External review": "Externá recenzia",
    Home: "Úvod",
    "Game not found! Please, go to ": "Hra sa nenašla! Prosím, choďte do sekcie ",
    " section and try to search again": " a skúste hľadať znova",
    "Showing games": "Zobrazujem hry",
    "with title starting by": "s názvom začínajúcim na",
    Adventure: "Adventúra",
    Action: "Akčná",
    Fighting: "Bojová",
    Gambling: "Hazardná",
    Card: "Kartová",
    Puzzle: "Logická",
    Educational: "Náučná",
    Others: "Ostatné",
    Platformer: "Plošinovka",
    Simulator: "Simulátor",
    Table: "Stolová",
    Strategic: "Strategická",
    Shooter: "Strieľačka",
    Sport: "Športová",
    Text: "Textová",
    Racing: "Závodná",
    Stealth: "Zakrádacia",
    Zombie: "Zombíci",
    Horror: "Hororová",
    "3rd Person": "Pohľad tretej osoby",
    Survival: "Prežitie",
    Military: "Vojenská",
    "from genre": "zo žánru",
    "Show games from genre": "Zobraziť hry z žánru",
    "Show games from platform": "Zobraziť hry platformy",
    "from platform": "platformy",
    Other: "Ostatné",
    Cover: "Obal",
    Manual: "Manuál",
    Instructions: "Návod",
    Cheats: "Cheaty",
    "Meta Description": "Meta - Popis stránky",
    "Meta Keywords": "Meta - Kľúčové výrazy",
    "Some of the materials from ZX Spectrum section was used with kind permission of the author of server":
        "Do ZX Spectrum sekcie som použil aj materiály s láskavým dovolením autora serveru",
    images: "obrázky",
    "new generation personal computers": "počítače novej generácie",
    "and arcade emulator": "a emulátor automatových hier",
    "Browse pages": "Prehliadať stránky",
};
